// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"3d68465d","682":"db44232d"}[chunkId] + ".chunk.js";
};